import React from 'react'
import Header from '../../component/Header'
import Footer from '../../component/Footer'
import HealthcareInformatics from '../HealthcareInformatics'

export default function LayoutHealthcareInformatice() {
    return (
        <div>
            <Header />
            <HealthcareInformatics />
            <Footer />
        </div>
    )
}
